
// node_modules
import {
    FC,
    useCallback,
    useContext,
    useEffect
} from "react";
// Stores
import { CaseContext } from "Stores";
// Types
import { TTechnology } from "Types";
// styles
import styles from "./conceptTechnologyList.module.scss";
// Interfaces
import { ICaseSelectedTechnology, ICaseSetSelectedEntity } from "Interfaces";
// Enums
import { CaseActionTypeEnum, CasePageEnum, VoteTypeEnum } from "Enums";
// Constants
import { CasePhaseConstants } from "Constants";
// Components
import { PhaseListItem } from "./PhaseListItem/PhaseListItem";

type TConceptTechnologyListProps = {
    isAdditionalResultsEnabled?: boolean
}

export const ConceptTechnologyList: FC<TConceptTechnologyListProps> = ({ isAdditionalResultsEnabled }: TConceptTechnologyListProps) => {
    // Shared states
    const { caseState, caseDispatch } = useContext(CaseContext);

    // Logic
    const setDisplaySelected = useCallback((casePageName: CasePageEnum) => {
        caseDispatch({
            type: CaseActionTypeEnum.SetCaseSelectedEntity, selectedEntityId: -1,
            selectedEntityName: casePageName, selectedEntityNumbering: ""
        } as ICaseSetSelectedEntity);
    }, [caseDispatch]);

    useEffect(() => {
        if (caseState.conceptTechnologyList) {
            if (caseState.selectedConceptId) { return; }

            // get all technology as an array
            const allTechnology: TTechnology[] = [];
            for (const concept of caseState.conceptTechnologyList.concepts) {
                allTechnology.push(...concept.technologies.flat());
            }
            allTechnology.push(...caseState.conceptTechnologyList.additionalTechnologies);
            
            for (const technology of allTechnology) {
                // come from Search section
                if (!caseState.selectedTechnologyId &&
                    caseState.selectedOriginalTechnologyId &&
                    ((!technology.isUserAdded && technology.originalTechnologyId &&
                        technology.originalTechnologyId === caseState.selectedOriginalTechnologyId) || 
                        (technology.isUserAdded &&
                            technology.id === caseState.selectedOriginalTechnologyId))) {
                    caseDispatch({
                        type: CaseActionTypeEnum.SetCaseSelectedTechnology,
                        selectedTechnologyId: technology.id,
                        selectedOriginalTechnologyId: technology.originalTechnologyId,
                        selectedEntityName: technology.name,
                        selectedEntityNumbering: technology.numbering
                    } as ICaseSelectedTechnology);
                    return;
                    // clicked on a published technology
                } else if (caseState.selectedTechnologyId &&
                    technology.id === caseState.selectedTechnologyId &&
                    caseState.selectedOriginalTechnologyId &&
                    technology.originalTechnologyId &&
                    technology.originalTechnologyId === caseState.selectedOriginalTechnologyId) {
                    caseDispatch({
                        type: CaseActionTypeEnum.SetCaseSelectedTechnology,
                        selectedTechnologyId: technology.id,
                        selectedOriginalTechnologyId: technology.originalTechnologyId,
                        selectedEntityName: technology.name,
                        selectedEntityNumbering: technology.numbering
                    } as ICaseSelectedTechnology);
                    return;
                    // clicked on an additional results technology
                } else if (caseState.selectedTechnologyId &&
                    technology.id === caseState.selectedTechnologyId &&
                    !caseState.selectedOriginalTechnologyId) {
                    caseDispatch({
                        type: CaseActionTypeEnum.SetCaseSelectedTechnology,
                        selectedTechnologyId: technology.id,
                        selectedOriginalTechnologyId: technology.originalTechnologyId,
                        selectedEntityName: technology.name,
                        selectedEntityNumbering: technology.numbering
                    } as ICaseSelectedTechnology);
                    return;
                }
            }

        }

        if(caseState.selectedEntityName) {
            if(caseState.selectedEntityName === CasePageEnum.Radar || caseState.selectedEntityName === CasePageEnum.RequiremenstTable) {
                return;
            }
        }
        // otherwise, set case phase overview as default content
        setDisplaySelected(CasePageEnum.Overview);

    }, [setDisplaySelected,
        caseDispatch,
        caseState.conceptTechnologyList,
        caseState.selectedOriginalTechnologyId,
        caseState.selectedEntityName,
        caseState.casePhase,
        caseState.selectedConceptId,
        caseState.selectedTechnologyId]);

    return (
        <aside className={styles.conceptTechnologyList}>
                { caseState.selectedCase?.isPhaseOnePublished ? 
                    <PhaseListItem 
                        phaseName="Phase 1" 
                        phaseNameConstant={CasePhaseConstants.PHASE_1} 
                        isAdditionalResultsEnabled={isAdditionalResultsEnabled} 
                        votingType={VoteTypeEnum.YesNoSuper} 
                        setDisplaySelected={setDisplaySelected} />
                    : null}
                { caseState.selectedCase?.isPhaseTwoPublished ?
                    <PhaseListItem 
                        phaseName="Phase 2" 
                        phaseNameConstant={CasePhaseConstants.PHASE_2} 
                        isAdditionalResultsEnabled={isAdditionalResultsEnabled} 
                        votingType={VoteTypeEnum.FiveStars} 
                        setDisplaySelected={setDisplaySelected} />
                    : null}
        </aside>
    );
};